import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	HttpClientModule,
	HttpClient,
	HTTP_INTERCEPTORS,
} from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';
import { AppComponent } from './app.component';
import { AgmCoreModule } from '@agm/core';
import {
	TranslateLoader,
	TranslateModule,
	TranslateService,
} from '@ngx-translate/core';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './reducers';
import { environment } from 'environments/environment';
import { EffectsModule } from '@ngrx/effects';
import { ToastrModule } from 'ngx-toastr';
import { AuthEffects } from './modules/auth/_state/auth.effects';
import { AuthInterceptor } from './modules/auth/_services/auth.interceptor.service';
import { SharedModule } from './shared/shared.module';
import { DashboardEffects } from './modules/dashboard/_state/dashboard.effects';

// console.log all actions
// export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
//   return function(state, action) {
//     console.log('state', state);
//     console.log('action', action);

//     return reducer(state, action);
//   };
// }

// export const metaReducers: MetaReducer<any>[] = [debug];

@NgModule({
	imports: [
		BrowserAnimationsModule,
		FormsModule,
		ReactiveFormsModule,
		HttpClientModule,
		ComponentsModule,
		RouterModule,
		SharedModule,
		AppRoutingModule,
		ToastrModule.forRoot(),
		AgmCoreModule.forRoot({
			apiKey: 'YOUR_GOOGLE_MAPS_API_KEY',
		}),
		EffectsModule.forRoot([
			AuthEffects,
			DashboardEffects,
		]),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		StoreModule.forRoot(reducers, {
			metaReducers,
			runtimeChecks: {
				strictStateImmutability: true,
				strictActionImmutability: true,
			},
		}),
		StoreDevtoolsModule.instrument({
			maxAge: 25,
			logOnly: environment.production,
		}),
	],
	declarations: [AppComponent, AdminLayoutComponent,],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		},
		{
			provide: APP_INITIALIZER,
			useFactory: appInitializerFactory,
			deps: [TranslateService],
			multi: true,
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
	return new TranslateHttpLoader(http);
}

export function appInitializerFactory(translate: TranslateService) {
	return async () => {
		translate.setDefaultLang('en');
		await translate.use('fr').toPromise();
		await translate.use('es').toPromise();
		await translate.use('pt').toPromise();
		const returnValue = await translate.use('en').toPromise();
		return returnValue;
	};
}
